import Keyb from "keyb"
import shortid from "shortid"
// import merge from "lodash.merge"
// import clonedeep from "lodash.clonedeep"
// const Lodash = {merge, clonedeep}

// import Draft from "@frog/source/models/Draft.js"
function KeySet(array) {
    const set = {}
    array.forEach((value, index) => set[value.key || index] = value)
    return set
}

// import {DraftEncounter, CombatEncounter} from "@frog/source/models/Encounter.js"
import CombatEncounter from "@frog/source/models/CombatEncounter.js"

export default class Game {
    constructor() {
        // game = Lodash.clonedeep(game)

        // this.index = that.index
        //
        // this.player = game.player
        // this.overworld = game.overworld
        //
        // this.events = game.events
        //
        // this.party = game.party
        // // this.party = this.party.map((unit) => {
        // //     return Lodash.merge({}, this.referenceUnit(unit), unit)
        // // })
        // this.party = new KeySet(this.party)

        // this.draft = new Draft({
        //     "units": this.index.reference.units,
        //     "counts": {
        //         "rarity:1": 5,
        //         "rarity:2": 4,
        //         "rarity:3": 3,
        //         "rarity:4": 2,
        //         "rarity:5": 1,
        //     }
        // })
    }
    update(delta) {
        if(this.encounter != undefined
        && this.encounter.update != undefined) {
            this.encounter.update(delta)
        }
    }
    load(game) {
        if(game.encounter != undefined) {
            if(game.encounter.type == "combat") {
                this.encounter = CombatEncounter.load(game.encounter)
            }
            // else if(encounter.type == "draft") {
            //     this.encounter = DraftEncounter.load(game.encounter)
            // }

        }
        return this
    }
}
